import "./assets/plugins/animate/animate.min.css";
import "./assets/plugins/font/css/font-awesome.min.css";
import "./assets/plugins/icons/css/simple-line-icons.css";
import "./assets/plugins/system-base/css/TabPanel.css";
import "./assets/plugins/common/aeeacs.css";
import "./assets/plugins/adminlte/css/AdminLTE.css";
import "./assets/plugins/adminlte/css/skins/skin-blue.css";
import "./assets/plugins/modules/sys/sysIndex.css";
import 'bootstrap/dist/css/bootstrap.min.css';

import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import 'bootstrap/dist/js/bootstrap.min.js';

Vue.config.productionTip = false;

router.beforeEach((to, from, next)=>{
	store.commit('setShowReturnBackBtn',false);
	next();
});

import '@/plugins/globalVuePlugins';

let $root = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');


window.$root = $root;
